import { BlackScreen } from "./styled";

const Overlay = ({ isMenuActive, opacity }) => {
  return <BlackScreen className={isMenuActive ? "on" : ""} opacity={opacity} />;
};

export default Overlay;
